import { lazyWithRetry } from '@repo/error';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';
import type { AppRouteObject } from '@router/types';

const FileDownloadPage = lazyWithRetry(() => import('@features/files/pages/FileDownloadPage'));

export const filesRoutes: AppRouteObject[] = [
  {
    path: ROUTE_PATHS[RouteName.FILES_DOWNLOAD],
    name: RouteName.FILES_DOWNLOAD,
    element: <FileDownloadPage />,
  },
];
